import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { CButton, CForm, CFormInput, CFormLabel } from "@coreui/react-pro";
import VisibilitySensor from "react-visibility-sensor";
import { useAlert } from "../../../contexts/AlertContext";
import { subscribe } from "../../../services/subscribe";
import { trackLead } from "../../../utils/tracking";

const DEFAULT_FORM_DATA = { email: "", isResponseLoading: false };

function Newsletter() {

  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  const [formData, setFormData] = useState(DEFAULT_FORM_DATA)
  const { showAlert, hideAlert } = useAlert()

  const handleSubscribe = async () => {

    hideAlert()

    setFormData(prev => ({ ...prev, isResponseLoading: true }))

    if (!formData.email.trim() || !formData.email.includes('@') || !formData.email.includes('.com')) {
      showAlert(t('newsletter_invalid_email'))
      setFormData(prev => ({ ...prev, isResponseLoading: false }))
      return
    }

    const res = await subscribe(formData.email)

    if (res.success) {
      trackLead('newsletter')
    }

    showAlert(res.message, res.success ? 'success' : 'error')

    setFormData(DEFAULT_FORM_DATA)
  }

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={400}>
        <div className={`newsletter-bg ${isVisible ? 'visible' : ''}`}>
          <div className="newsletter">
          <h1 className={`${isVisible ? 'visible' : ''}`}>{t("newsletter_title")} <span>{t("newsletter_title_span")}</span></h1>
          <div className={`line ${isVisible ? 'visible' : ''}`}></div>
          <CForm id="newsletterForm" className={`${isVisible ? 'visible' : ''}`}>
            <CFormLabel htmlFor="emailinput">{t("newsletter_email_label")}</CFormLabel>
            <CFormInput
              id="emailinput"
              type="email"
              className="me-2"
              placeholder={t("newsletter_email_placeholder")}
              value={formData.email}
              onChange={e => setFormData(prev => ({ ...prev, email: e.target.value }))}
            />
            <CButton
              className="mt-2"
              disabled={formData.isResponseLoading}
              onClick={handleSubscribe}
            >
              {formData.isResponseLoading ? t("newsletter_sending") : t("newsletter_send")}
            </CButton>
          </CForm>
        </div>
      </div>
    </VisibilitySensor>
  );
}

export default Newsletter;
